export enum ImageSectionType {
  HOME_PAGE = 'home-page',
  PRODUCT_PAGE = 'product-page',
}
